if (!customElements.get("custom-collection-layout-selector-button")) {
    class CustomCollectionLayoutSelectorButton extends HTMLElement {
        constructor() {
            super();
            this.inputElement = this.querySelector("input");
        }

        connectedCallback() {
            this.addEventListener("change", this.onChange.bind(this));
            this.onLoad();
        }

        onLoad() {
            const productList = this.closest(".collection").querySelector(".product-list");
            if (productList && !productList.dataset.layoutChecked) {
                productList.dataset.layoutChecked = "true";
                const desktopLayout =
                    productList.getAttribute("desktop-layout");
                const mobileItemsPerRow = productList.getAttribute(
                    "mobile-items-per-row"
                );
                const desktopLayoutInput = document.querySelector(
                    `[name="desktop-layout"][value="${desktopLayout}"]`
                );
                if (desktopLayoutInput) {
                    desktopLayoutInput.checked = true;
                }

                const mobileItemsPerRowInput = document.querySelector(
                    `[name="mobile-items-per-row"][value="${mobileItemsPerRow}"]`
                );
                if (mobileItemsPerRowInput) {
                    mobileItemsPerRowInput.checked = true;
                }

                // Sticky toolbar inputs (if present)
                const desktopLayoutStickyInput = document.querySelector(
                    `[name="desktop-layout-sticky"][value="${desktopLayout}"]`
                );
                if (desktopLayoutStickyInput) {
                    desktopLayoutStickyInput.checked = true;
                }

                const mobileItemsPerRowStickyInput = document.querySelector(
                    `[name="mobile-items-per-row-sticky"][value="${mobileItemsPerRow}"]`
                );
                if (mobileItemsPerRowStickyInput) {
                    mobileItemsPerRowStickyInput.checked = true;
                }
                document.documentElement.dispatchEvent(
                    new CustomEvent("layout:change", { bubbles: true })
                );
            }
        }

        onChange() {
            const productList = this.closest(".collection").querySelector(".product-list");
            if (!productList) return;
            let attributes = {};
            if (this.inputElement.name === "desktop-layout") {
                attributes["product_card_desktop_layout"] =
                    this.inputElement.value;
            } else if (this.inputElement.name === "mobile-items-per-row") {
                attributes["product_card_mobile_items_per_row"] = parseInt(
                    this.inputElement.value
                );
            }
            fetch(`${Shopify.routes.root}cart/update.js`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    attributes,
                }),
            });

            switch (this.inputElement.name) {
                case "mobile-items-per-row":
                case "mobile-items-per-row-sticky":
                    productList.setAttribute(
                        "mobile-items-per-row",
                        this.inputElement.value
                    );
                    // Update the other mobile selector
                    const otherMobileSelector =
                        this.inputElement.name === "mobile-items-per-row"
                            ? "mobile-items-per-row-sticky"
                            : "mobile-items-per-row";
                    this.updateOtherSelectors(otherMobileSelector);
                    break;

                case "desktop-layout":
                case "desktop-layout-sticky":
                    productList.setAttribute(
                        "desktop-layout",
                        this.inputElement.value
                    );
                    // Update the other desktop selector
                    const otherDesktopSelector =
                        this.inputElement.name === "desktop-layout"
                            ? "desktop-layout-sticky"
                            : "desktop-layout";
                    this.updateOtherSelectors(otherDesktopSelector);
                    break;
            }

            window.scrollTo({ top: 0, behavior: "smooth" });

            if (window.themeVariables.settings.staggerProducts) {
                productList.reveal();
            }

            document.documentElement.dispatchEvent(
                new CustomEvent("layout:change", { bubbles: true })
            );
        }

        updateOtherSelectors(selectorName) {
            const otherDesktopElement = document.querySelector(
                `[name="${selectorName}"][value="${this.inputElement.value}"]`
            );
            if (otherDesktopElement) {
                otherDesktopElement.value = this.inputElement.value;
                otherDesktopElement.checked = true;
            }
        }
    }

    customElements.define(
        "custom-collection-layout-selector-button",
        CustomCollectionLayoutSelectorButton
    );
}
